export default __webpack_public_path__ + "static/media/botty-congrats.17b5c9e4.svg";